import { InputField } from "./InputField";
import { useFormContext } from "react-hook-form";

export const EmailAddress = ({ className, ...rest }) => {
  const { register, watch, formState, getValues, setValue } = useFormContext();
  return (<InputField label={"Email address"} type="email" {...register("registerEmail", { required: true })} className={className} {...rest} validate={{
    emailValid: value => (/\S+@\S+\.\S+/.test(value) ? true : "Invalid Email address format")
  }} />);
};
